import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Component, Inject, ChangeDetectorRef, OnInit, OnChanges, ViewChild, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AppointmentMaster, Appointment, RecurringAppointment } from '@models/appointments/appointment.model';
import { AppointmentService } from '@service/appointment.service';
import { PatientAlert } from '@models/patient-facesheet/patient-alert.model';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { TimeslotconfirmDialogComponent } from '@pages/appointments/appointment/slot-selection/dialog/timeslotconfirm/timeslotconfirm.component';
import { ProviderconfirmDialogComponent } from '@pages/appointments/appointment/slot-selection/dialog/providerconfirm/providerconfirm.component';
import { RecurringconfirmDialogComponent } from '../recurringconfirm-dialog/recurringconfirm.component';

import * as _ from 'underscore';
import { CustomWarningDialogComponent } from '../../../../module/custom-warning-popup/custom-warning.component';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingHelper } from '@helpers/routinghelper';
import { NgxSpinnerService } from "ngx-spinner";
import { MatSelect } from '@angular/material/select';
import { select } from 'underscore';

@Component({
  selector: 'app-appointment-dialog',
  templateUrl: './appointment-dialog.component.html',
  styleUrls: ['./appointment-dialog.component.sass']
})
export class AppointmentDialogComponent extends ValueAccessorHelper<any> implements OnInit, OnChanges {
  action: string;
  dialogTitle: string;
  apiURL: string;
  calendarForm: FormGroup;
  appointment: Appointment;
  masters: AppointmentMaster;
  showRoomWaring: boolean = false;
  showEquipmentWarning: boolean = false;
  CaseName: any;
  priorcount: number = 0;
  remainingcount: number = 0;
  noofunits: number = 0;
  insuranceselfpaygroup: any;
  provider: string = '';
  patient: string = '';
  appointmentId: number = 0;
  showProviderError: boolean = false;
  providerError: string = '';
  invalidLocation: boolean = false;
  showAlert: boolean = false;
  warningText: string = '';
  showDeleteBtn = false;
  serviceLocations: any = [];
  Rooms: any;
  Equipments: any;
  submitted: boolean = false;
  visit: string = '';
  location: string = '';
  public IstimeError: boolean = false;
  public IsstarttimeError: boolean = false;
  formType: string;
  postURL: string;
  returnUrl: string;
  isPresent: boolean;
  isDisabled: boolean = false;
  isRepeating: boolean = false;
  isDayRepeat: boolean = true;
  isWeekRepeat: boolean = false;
  appointmentArray: Array<any> = [];
  meetingCount: number = 0;
  selectedWeekCount: number = 0;

  public recurringappointment = 'Does Not Repeat';
  @ViewChild(MatSelect) matSelect: MatSelect;
  minStartTime: any;

  constructor(
    public dialogRef: MatDialogRef<AppointmentDialogComponent>,
    public slotDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public appointmentService: AppointmentService,
    public datepipe: DatePipe,
    private fb: FormBuilder,
    private cdf: ChangeDetectorRef,
    private helper: BeyondEMRHelper,
    private route: ActivatedRoute,
    private router: Router,
    private routingHelper: RoutingHelper,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {
    super();
    // Set the defaults
    dialogRef.disableClose = true;
    this.action = data.action;
    this.apiURL = data.apiURL;
    this.minStartTime = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss');

    let id = this.routingHelper.GetRoutingParamerterId(this.route.params);
    if (this.action === 'edit') {
      this.dialogTitle = data.calendar.title;
      this.appointment = new Appointment();
      this.getData(data.calendar.Id);
      this.masters = data.masters;
      this.appointmentId = data.calendar.Id;
      this.showDeleteBtn = true;
    } else {
      this.dialogTitle = 'New Event';
      this.appointment = data.calendar;
      this.appointment.RecurringData = this.appointment.RecurringData ? this.appointment.RecurringData : new RecurringAppointment();
      this.appointment.RecurringData.StartDate = this.appointment.AppointmentDate;
      this.appointment.ProviderId = localStorage.getItem("id") as any;
      this.appointment.Id = 0;

      this.masters = data.masters;

      this.masters.PersonalDetails = this.masters.PersonalDetails.filter((existing) => {
        return existing['DisplayInList'] == true && existing['Active'] == true;
      });
      this.masters.VisitReasons = this.masters.VisitReasons.filter((existing) => {
        return existing['DisplayInList'] == true && existing['Active'] == true;
      });
      this.masters.ServiceLocations = this.masters.ServiceLocations.filter((existing) => {
        return existing['DisplayInList'] == true && existing['Active'] == true;
      });


      if (this.appointment.PatientId > 0) {
        this.patient = this.helper.filterByMaster(this.appointment.PatientId, this.masters.PatientDetails, 'FullName');
        this.bindAlert();
      }
      if (this.appointment.ProviderId > 0) {
        this.provider = this.helper.filterByMaster(this.appointment.ProviderId, this.masters.PersonalDetails, 'FullName');
        this.getProviderSlots(true);
      }
      if (this.appointment.VisitReasonId > 0) {
        this.visit = this.helper.filterByMaster(this.appointment.VisitReasonId, this.masters.VisitReasons, 'FullName');
      }

      if (this.appointment.PatientId > 0) {
        this.getInsuranceCase();
      }
      this.showDeleteBtn = false;
    }
  }
  ngOnInit() {
    this.cdf.detectChanges();
  }

  ngOnChanges() {
    this.cdf.detectChanges();
  }

  getData(appointmentId) {
    this.appointmentService.GetAppointmentDetails(this.apiURL + "appointment/GetAppointment/" + appointmentId).subscribe(result => {
      let data = result as Appointment;
      this.appointment = data;
      this.isRepeating = this.appointment.RecurringAppointmentId > 0 ? true : false;
      this.appointment.RecurringData = this.appointment.RecurringData ? this.appointment.RecurringData : new RecurringAppointment();
      this.appointment.RecurringData.StartDate = this.appointment.RecurringData.StartDate ? this.appointment.RecurringData.StartDate : this.appointment.AppointmentDate;
      this.isDayRepeat = this.appointment.RecurringData.PatternId == 1 ? true : false;
      this.isWeekRepeat = this.appointment.RecurringData.PatternId == 2 ? true : false;
      this.appointment.RecurringData.Weeks = this.getWeekConfiguration();
      this.appointment.RecurringData.EndDate = this.appointment.RecurringData.EndDate ? this.datepipe.transform(this.appointment.RecurringData.EndDate, "MM/dd/yyyy") : "";

      this.provider = this.helper.filterByMaster(this.appointment.ProviderId, this.masters.PersonalDetails, 'FullName');
      this.patient = this.helper.filterByMaster(this.appointment.PatientId, this.masters.PatientDetails, 'FullName');
      this.visit = this.helper.filterByMaster(this.appointment.VisitReasonId, this.masters.VisitReasons, 'Name');
      this.location = this.helper.filterByMaster(this.appointment.ServiceLocationId, this.masters.ServiceLocations, 'Name');
      this.isDisabled = this.appointment?.Id > 0 && this.appointment.StatusId >= BeyondEMRConstants.STATUS.Open_Notes ? true : false;

      this.bindAlert();
      this.getInsuranceCase();
      this.getProviderSlots(false);
      this.getRoomEquipments();
      if (this.minStartTime > this.appointment.AppointmentDate) {
        this.minStartTime = this.datepipe.transform(this.appointment.AppointmentDate, 'yyyy-MM-ddTHH:mm:ss');
      }
    });
  }

  getWeekConfiguration() {

    let weekData = this.appointment.RecurringData.WeekConfiguration ? JSON.parse(this.appointment.RecurringData.WeekConfiguration) : [];
    let data = [
      { DayId: 1, DayName: "Sunday", ShortName: "S", RowOrder: 0, IsChecked: false },
      { DayId: 2, DayName: "Monday", ShortName: "M", RowOrder: 100, IsChecked: false },
      { DayId: 3, DayName: "Tuesday", ShortName: "T", RowOrder: 200, IsChecked: false },
      { DayId: 4, DayName: "Wednesday", ShortName: "W", RowOrder: 300, IsChecked: false },
      { DayId: 5, DayName: "Thursday", ShortName: "T", RowOrder: 400, IsChecked: false },
      { DayId: 6, DayName: "Friday", ShortName: "F", RowOrder: 500, IsChecked: false },
      { DayId: 7, DayName: "Saturday", ShortName: "S", RowOrder: 600, IsChecked: false }
    ];

    data = _.each(data, function (x) {
      if (weekData.filter(dt => dt == x.DayId).length > 0) {
        x.IsChecked = true;
      }
      return x;
    })

    return data;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onChangeVisitReason(item) {
    this.appointment.VisitReasonId = item && item['Id'] || 0;

    this.appointment.Duration = this.appointment.VisitReasonId > 0 ? this.masters.VisitReasons.find(x => x.Id == this.appointment.VisitReasonId).Duration : 0;
    this.bindEndTime();
  }

  onChangeRoom(item) {
    if (this.appointment.RoomId > 0) {
      this.appointment.StartTime = this.datepipe.transform(this.appointment.StartTime, 'yyyy-MM-ddTHH:mm:ss');
      this.appointmentService.GetRoomDetails(this.apiURL + 'appointment/RoomDetails', this.appointment).subscribe(data => {
        if (data == 1) {
          this.showRoomWaring = true;
        }
        else {
          this.showRoomWaring = false;
        }
      });
    }
  }

  onChangeEquipment(item) {
    this.appointment.StartTime = this.datepipe.transform(this.appointment.StartTime, 'yyyy-MM-ddTHH:mm:ss');
    if (this.appointment.EquipmentId > 0) {
      this.appointmentService.GetEquipmentDetails(this.apiURL + 'appointment/EquipmentDetails', this.appointment).subscribe(data => {
        if (data == 1) {
          this.showEquipmentWarning = true;
        }
        else {
          this.showEquipmentWarning = false;
        }
      });
    }
  }

  getProviderSlots(clearData) {
    this.appointment.AppointmentDate = this.datepipe.transform(this.appointment.StartTime, 'yyyy-MM-dd');
    if (this.apiURL) {
      this.appointmentService.GetSlots(this.apiURL + 'appointment/ProviderTimeSlot', this.appointment).subscribe(loc => {

        this.serviceLocations = loc;
        if (loc?.length == 0) {
          this.serviceLocations = [];
          this.location = '';
          this.showProviderError = this.appointment.ProviderId > 0 ? true : false;
          this.providerError = "The provider does not have any slot for the current date. Either the provider have the holiday or week off on that day.";
        }
        else {

          var ids = [], l = this.masters.ServiceLocations.length, i;
          for (i = 0; i < l; i++) {
            ids.push(this.masters.ServiceLocations[i].Id);
          }

          if (this.action === 'create') {
            this.serviceLocations = loc?.filter(x => ids.includes(x.ServiceLocationId));
            if (this.serviceLocations?.length == 0) {
              this.location = '';
            }
          }
          this.showProviderError = false;
          this.providerError = "";
        }
      });
      if (clearData) {
        this.appointment.RoomId = null;
        this.appointment.EquipmentId = null;
      }
    }
  }

  bindEndTime() {
    this.appointment.RecurringData.StartDate = this.appointment.AppointmentDate;
    let startTime = this.appointment.StartTime;

    if (this.appointment.Duration && this.appointment.Duration > 0) {
      let endTime = new Date(new Date(startTime).getTime() + (this.appointment.Duration * 60000));
      this.appointment.EndTime = this.datepipe.transform(endTime, 'yyyy-MM-ddTHH:mm:ss');
    }

    this.appointment.ServiceLocationId = 0;
    this.location = "";
    this.getProviderSlots(true);
  }

  bindDuration() {
    let msec = new Date(this.appointment.EndTime).getTime() - new Date(this.appointment.StartTime).getTime();
    let mins = Math.floor(msec / 60000);

    if (mins > 0) {
      this.appointment.Duration = mins;
    }
  }

  onChangecase() {

    let id = this.appointment.InsuranceCaseId;
    if ((id <= 0) || id == undefined || id == null) {
      id = this.CaseName?.filter(x => x.IsPrimary == true)[0]?.InsuranceCaseId;
      this.appointment.InsuranceCaseId = id;
    }
    if (id > 0 || id != null) {
      this.priorcount = this.CaseName?.find(items => items.InsuranceCaseId == id)?.PriorCount || '';
      this.noofunits = this.CaseName?.find(items => items.InsuranceCaseId == id)?.NoOfUnits || '';
      let count = this.CaseName?.find(items => items.InsuranceCaseId == id)?.NoOfUnits || '';
      if (count != null && count != '') {
        this.remainingcount = this.noofunits - this.priorcount;
        this.appointment.InsuranceCaseId = id;
        if (this.remainingcount < 0) {
          this.remainingcount = 0;
        }
        var priorauthorization = this.remainingcount + ' of ' + this.noofunits + ' Visits Remaining';
        this.appointment.Autharization = priorauthorization;
      }
      else {
        this.appointment.Autharization = null;
      }
    }
  }

  onChangePatient(item) {
    this.appointment.PatientId = item && item['Id'] || 0;
    if (this.appointment.PatientId > 0) {
      this.bindAlert();
      this.getInsuranceCase();
    }
  }

  onChangeProvider(item) {
    this.appointment.ProviderId = item && item['Id'] || 0;
    if (this.appointment.ProviderId > 0) {
      this.appointment.ServiceLocationId = 0;
      this.location = '';
      this.getProviderSlots(true);
      if (this.appointmentId != null) {
        this.masters.PatientDetails = this.helper.bindMaster(this.masters.PatientDetails, this.appointmentId, this.appointment.PatientId);
      }
    }
  }

  onChangeLocation(item) {
    this.appointment.ServiceLocationId = item && item['ServiceLocationId'] || 0;
    this.getRoomEquipments();
  }

  getRoomEquipments() {
    if (this.appointment.ServiceLocationId > 0) {
      this.Rooms = this.masters.Rooms?.filter(x => x.ServiceLocationId == this.appointment.ServiceLocationId);
      this.Rooms = this.Rooms.filter((existing) => {
        return existing['DisplayInList'] == true && existing['Active'] == true;
      });
      this.Equipments = this.masters.Equipments?.filter(x => x.ServiceLocationId == this.appointment.ServiceLocationId);
      this.Equipments = this.Equipments.filter((existing) => {
        return existing['DisplayInList'] == true && existing['Active'] == true;
      });
      if (this.appointmentId != null) {
        this.Rooms = this.helper.bindMaster(this.Rooms, this.appointmentId, this.appointment.RoomId);
        this.Equipments = this.helper.bindMaster(this.Equipments, this.appointmentId, this.appointment.EquipmentId);
      }
    }
  }

  bindAlert() {
   
  }

  getInsuranceCase() {
    this.appointmentService.GetPatientInsurance(this.apiURL + "appointment/GetInsurancecaseByPatientId/" + this.appointment.PatientId).subscribe(result => {
      if (result) {
        let dataItems = result;
        this.CaseName = result;
        var results = [];

        if (this.CaseName.filter(i => i.NAME == "Insurance").length > 0) {
          results.push({
            name: "Insurance",
            values: this.CaseName.filter(i => i.NAME == "Insurance")
          })
        }
        results.push({
          name: "SelfPay",
          values: this.CaseName.filter(i => i.NAME == "SelfPay")
        })
        this.insuranceselfpaygroup = results;
        this.onChangecase();
      }
      else {
        this.insuranceselfpaygroup = [];
      }
    });

  }

  validateTypeahead(): any {
    let result = true;

    if (this.appointment.ServiceLocationId <= 0 || this.location.length <= 0) {
      this.invalidLocation = true;
      result = false;
    }
    if (this.appointment.ProviderId <= 0 || this.provider.length <= 0) {
      result = false;
    }
    if (this.appointment.PatientId <= 0 || this.location.length <= 0) {
      result = false;
    }
    if (this.appointment.VisitReasonId <= 0 || this.visit.length <= 0) {
      result = false;
    }
    var startDate = this.datepipe.transform(this.appointment.StartTime, 'yyyy-MM-dd HH:mm');
    var endDate = this.datepipe.transform(this.appointment.EndTime, 'yyyy-MM-dd HH:mm');

    if (startDate == endDate) {
      this.IstimeError = true;

      result = false;
    }

    return result;
  }

  saveAppointment() {
    this.isDisabled = true;
    this.submitted = true;

    if (!this.validateTypeahead()) {
      this.isDisabled = false;
      return false;
    }
    if (this.isRepeating == true && this.appointment.RecurringData.PatternId == 2) {
      this.calculateSelectedCount();

      if (this.selectedWeekCount == 0) {
        this.isDisabled = false;
        return false;
      }
    }

    this.checkSelectedSlot(this.appointment);
  }

  calculateSelectedCount() {
    this.selectedWeekCount = 0;
    let that = this;

    _.each(this.appointment.RecurringData.Weeks, function (x) {
      if (x.IsChecked == true) {
        that.selectedWeekCount = that.selectedWeekCount + 1;
      }
    });
  }

  checkSelectedSlot(appointment: Appointment) {
    let appointmentDate = this.datepipe.transform(this.appointment.AppointmentDate, BeyondEMRConstants.DateDBFormat);
    let startTime = this.datepipe.transform(this.appointment.StartTime, 'MM/dd/yyyy HH:mm');


    this.appointmentService.CheckForExistingSlot(this.apiURL + 'appointment/IsExistingSlot/', appointment.Id, appointment.ProviderId, startTime, appointmentDate).subscribe(data => {
      if (data && data?.length > 0) {
        let patientName = '';

        _.each(data, function (x) {
          patientName = patientName != '' ? patientName + ', ' + x.PatientName : x.PatientName;
        });

        const confirmdialogRef = this.slotDialog.open(TimeslotconfirmDialogComponent, {
          width: '600px',
          data: {
            patient: this.appointment,
            confirmationType: 'Timeslotconfirm',
            patientName: patientName
          },
        });
        confirmdialogRef.afterClosed().subscribe((result) => {
          if (result === true) {
            this.checkTimeOffEvent();
          }
          else {
            this.submitted = false;
            this.isDisabled = false;
          }
        });
      }
      else {
        this.checkTimeOffEvent();
      }
    });
  }

  checkTimeOffEvent() {

    let locationId = this.location ? <any>this.masters.ServiceLocations.filter(item => item.Name == this.location)[0].Id : '';
    this.appointment.ServiceLocationId = locationId;
    this.appointmentService.ValidateTimeOffEvent(this.apiURL + 'appointment/ValidateTimeOffEvent', this.appointment).subscribe(result => {
      if (result == 0) {
        this.submit();
      }
      else {
        this.submitted = false;
        const dialogRef = this.slotDialog.open(CustomWarningDialogComponent, {
          width: '400px',
          data: {
            header: "Are you sure?",
            body: "This provider has applied time off event for the current slot. Do you want to create the appointment with current slot.",
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result == 1) {
            this.submit();
          }
          else {
            this.isDisabled = false;
          }
        });
      }
    });
  }

  submit() {
    this.appointment.StatusId = this.appointment.StatusId >= BeyondEMRConstants.STATUS.Scheduled ? this.appointment.StatusId : BeyondEMRConstants.STATUS.Scheduled;
    let startDate = new Date(this.appointment.StartTime);
    let endDate = new Date(this.appointment.EndTime);

    if (startDate != null && (endDate < startDate)) {
      this.IstimeError = true;
      this.submitted = false;
      return false;
    }
    else {
      this.CheckForProviderAvailability(this.appointment);
    }
  }

  validateEndTime() {
    this.IstimeError = false;
    this.bindDuration();
  }

  validateStartTime() {
    this.submitted = false;
    this.IsstarttimeError = false;
    let startDate = this.datepipe.transform(this.appointment.StartTime, 'MM/dd/yyyy HH:mm');
    let currentdate = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm');
    // if (new Date(currentdate) > new Date(startDate) && this.appointment.Id <= 0) {
    //   this.submitted = true;
    //   this.IsstarttimeError = true;
    // }
    // else {
    this.IsstarttimeError = false;
    this.bindEndTime();
    // }
  }

  bindMasters(id) {
    let isCreate = id > 0 ? false : true;
    if (this.masters != null) {
      this.masters.PersonalDetails = this.helper.bindMaster(this.masters.PersonalDetails, isCreate, this.appointment?.ProviderId);
    }
  }

  updateappoinment() {
    this.spinner.show();
    this.appointment.RecurringAppointmentId = this.appointment.RecurringAppointmentId > 0 ? this.appointment.RecurringAppointmentId : null;
    this.appointment.RecurringData.WeekConfiguration = this.isWeekRepeat ? this.GetWeekData() : null;
    this.appointment.RecurringData = this.isRepeating ? this.appointment.RecurringData : null;
    this.appointmentService.SaveAppointmentsDetails(this.apiURL + 'appointment/UpdateAppointment', this.appointment).subscribe(data => {
      if (data) {
        this.helper.showNotification('Appointment Record is ' + (this.appointmentId > 0 ? 'edited' : 'created') + ' Successfully...!!!');
        this.dialogRef.close(data.ProviderId);
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/appointments/appointment']);
        this.spinner.hide();
      }
    });
  }

  GetWeekData() {
    let weekData = [];

    let weeks = this.appointment.RecurringData.Weeks.filter(x => x.IsChecked == true)

    _.each(weeks, function (x) { weekData.push(x.DayId) });

    return weekData?.length > 0 ? JSON.stringify(weekData) : null;
  }

  CheckForProviderAvailability(appointment: Appointment) {
    var StartTime = this.datepipe.transform(this.appointment.StartTime, 'yyyy-MM-ddTHH:mm:ss');
    var EndTime = this.datepipe.transform(this.appointment.EndTime, 'yyyy-MM-ddTHH:mm:ss');
    let locationId = this.location ? <any>this.masters.ServiceLocations.filter(item => item.Name == this.location)[0].Id : '';

    this.appointmentService.CheckForProviderAvailability(this.apiURL + 'appointment/IsProviderAvailability/', this.appointment.ProviderId, StartTime, EndTime, locationId).subscribe(res => {
      this.isPresent = res as boolean;

      if (this.isPresent == true) {
        const confirmdialogRef = this.slotDialog.open(ProviderconfirmDialogComponent, {
          width: '500px',
          data: {
            providerName: this.provider
          },
        });
        confirmdialogRef.afterClosed().subscribe((result) => {
          if (result === true) {
            this.checkRecurringAppointment();
          }
          else {
            this.submitted = false;
            this.isDisabled = false;
          }
        });
      }
      else {
        this.checkRecurringAppointment();
      }
    });
  }

  checkRecurringAppointment() {
    if (this.appointment.RecurringAppointmentId > 0) {
      this.calculateMeetingCount();
      if (this.meetingCount > this.appointment.RecurringData.AppointmentCount) {
        this.submitted = false;
        this.isDisabled = false;

        return false;
      }

      const confirmdialogRef = this.slotDialog.open(RecurringconfirmDialogComponent, {
        width: '500px',
        data: {
          recurringAppointmentId: this.appointment.RecurringAppointmentId
        },
      });
      confirmdialogRef.afterClosed().subscribe((result) => {
        if (result === 1) {
          this.appointment.RecurringData.IsEdited = true;
          this.updateappoinment();
        }
        else if (result == 2) {
          this.appointment.RecurringData.IsEdited = false;
          this.updateappoinment();
        }
        else {
          this.appointment.RecurringData.IsEdited = false;
          this.submitted = false;
          this.isDisabled = false;
        }
      });
    }
    else {
      this.updateappoinment();
    }
  }

  calculateMeetingCount() {
    this.meetingCount = 0;
    if (this.appointment.RecurringAppointmentId > 0) {
      let appointmentCount = this.appointment.RecurringData.Appointments.filter(x => this.datepipe.transform(x.AppointmentDate, 'yyyy-MM-dd') <= this.appointment.AppointmentDate || x.StatusId != BeyondEMRConstants.STATUS.Scheduled)?.length ?? 0;
      this.meetingCount = appointmentCount;
    }
  }


  ngAfterViewInit() {
    this.matSelect.openedChange.subscribe(opened => {
      if (opened) {
        this.matSelect.panel.nativeElement.addEventListener('mouseleave', () => {
          this.matSelect.close();
        })
      }
    })
  }

  // recurring appointment
  changeRecurringType(typeId) {
    this.appointment.RecurringData = new RecurringAppointment();
    this.appointment.RecurringData.StartDate = this.appointment.AppointmentDate;
    this.selectedWeekCount = 0;
    if (this.isDayRepeat && typeId == 1) {
      this.isWeekRepeat = false;
      this.appointment.RecurringData.PatternId = 1;
    }
    else {
      this.isWeekRepeat = true;
      this.isDayRepeat = false;
      this.appointment.RecurringData.PatternId = 2;
    }
  }
}
